<template>
    <div class="learning-progress">
        <div class="progress_num">
            学习总进度 <span>{{ trainProgress }}%</span>
        </div>
        <div class="el_progress_box">
            <el-progress
                :percentage="Number(trainProgress)"
                :color="customColor"
                :show-text="false"
            ></el-progress>
            <img
                :src="finishImg"
                class="studyImg"
                alt=""
            />
        </div>
    </div>
</template>

<script>
export default {
    props:{
        trainProgress:{
            type:String,
            default:'0'
        },
    },
    computed:{
        finishLearning(){
            return this.trainProgress == '100' ? true : false;
        },
        finishImg(){
            let imgSrc = this.trainProgress == '100' ? require("@/assets/images/personal/studyImga.png") : require("@/assets/images/personal/studyImg.png");
            return imgSrc
        }
    },
    data(){
        return {
            customColor:'#b21f27'
        }
    }
}
</script>

<style>
.el_progress_box .el-progress {
  width: calc(100% - 30px);
}
</style>
<style lang="less" scoped>
.studyImg {
  width: 28px;
}
.el_progress_box {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.progress_num em {
  font-style: normal;
}
.progress_num span {
  color: #b72d35;
}
.progress_num {
  line-height: 42px;
  color: #818181;
  font-size: 16px;
}
</style>
